import { useDispatch, useSelector } from "react-redux";
import React from "react";
import kitcut from "../../utils/kitcut";
import hyphen from "../../utils/hyphen";

export const ReceivedGiftPopup = ({gift, popup, close}) => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const name = useSelector(state => state.user.name)

    function redirect() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
        if (isInstagram) {
            window.close();
        } else {
            window.location.href = "https://ig.me/m/" + name + "/";
        }
    }
    if (!popup || gift === null) return (null)
    else return (
        <div className="receivedGiftPopup">
            <div className="receivedGiftPopup__back" onClick={() => dispatch(close())}></div>
            <div className="receivedGiftPopup__wrap">
                <div className="receivedGiftPopup__box">
                    <div className="receivedGiftPopup__head">
                        {lang.games6}
                        <div className="receivedGiftPopup__close" onClick={() => dispatch(close())}>
                        </div>
                    </div>
                    {
                        gift.id === null && (
                            <div className="receivedGiftPopup__heading"><span>{lang.message7}</span></div>)
                    }
                    {
                        gift.id !== null && (
                            <div className="receivedGiftPopup__body">
                                <div className="receivedGift">

                                    <div className="receivedGift__img">
                                        <div className="receivedGift__circle">
                                            {gift.type === 'points'
                                                ? <div className="receivedGift__points">{'+' + gift.points}</div>
                                                : typeof gift.image !== 'undefined' && <img alt='gift' src={gift.image} />
                                            }
                                        </div>
                                    </div>
                                    <div className="receivedGift__name">{typeof gift.name !== 'undefined' && hyphen(kitcut(gift.name, 50))}</div>
                                    <div className="receivedGift__text">
                                        {gift.game === 'shop' ? lang.games17: lang.games7 }
                                    </div>
                                    <div className="receivedGift__button" onClick={() => redirect()}>
                                        <a href={"https://ig.me/m/" + name + "/"}>{lang.games8}</a>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}